export const LoadingIndicator = () => <div>Loading...</div>;
